// node_modules
import React, { useEffect, useState } from "react";

// @primereact
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Chip } from "primereact/chip";

// components
import { MobileSelectModalFooter } from "./MobileSelectModalFooter";
import { MobileSelectItem } from "./MobileSelectItem";

// assets
import SelectBtnIcon from "../../../../assets/select-btn-arrow.svg";

//utils
import { toggleSelectValue } from "../utils/toggleSelectValue";

// styles
import * as styles from "./MobileSelectModal.module.css";

export const MobileSelectModal = ({
  value = [],
  onChange,
  options,
  header,
  allowMultiple = true,
  max = Infinity,
  valueKey = "id",
  labelKey = "label",
  imageResolver,
  buttonText,
  labelMapper,
  infoIdResolver,
  disabled = false,
}) => {
  const [localValue, setLocalValue] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) setLocalValue(Array.isArray(value) ? value : []);
  }, [visible, value]);

  const toggleValue = (val) => {
    setLocalValue((prev) =>
      toggleSelectValue({
        current: prev,
        value: val,
        allowMultiple,
        max,
        exclusiveValue: "none",
      }),
    );
  };

  const handleSave = () => {
    onChange(localValue);
    setVisible(false);
  };

  const handleRemoveChip = (val) => {
    const updated = localValue.filter((v) => v !== val);
    setLocalValue(updated);
    onChange(updated);
  };

  return (
    <>
      <Button
        type="button"
        className={styles.mobileSelectBtn}
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          if (!disabled) setVisible(true);
        }}
      >
        {disabled ? (
          <div className={styles.chipsWrapper}>
            {(Array.isArray(value) ? value : [value])
              .filter(Boolean)
              .map((val) => (
                <Chip
                  key={val}
                  className={styles.chip}
                  label={labelMapper?.[val] || val}
                />
              ))}
          </div>
        ) : localValue.length ? (
          <div
            className={styles.chipsWrapper}
            onClick={(e) => e.stopPropagation()}
          >
            {localValue.map((val) => (
              <Chip
                key={val}
                className={styles.chip}
                label={labelMapper?.[val] || val}
                removable
                onRemove={() => handleRemoveChip(val)}
              />
            ))}
          </div>
        ) : (
          <span>{buttonText}</span>
        )}

        <div>
          <img src={SelectBtnIcon} width={40} height={14} />
        </div>
      </Button>

      <Dialog
        header={header}
        visible={visible}
        blockScroll
        closable={false}
        modal
        maskClassName="mobileSelectModalMask"
        className={classNames(styles.mobileSelectModal, "fullscreen-dialog")}
        onHide={() => setVisible(false)}
        footer={
          <MobileSelectModalFooter
            onSave={handleSave}
            onCancel={() => setVisible(false)}
          />
        }
      >
        <div className={styles.list}>
          {options.map((opt) => {
            const val = opt[valueKey];
            return (
              <MobileSelectItem
                key={val}
                label={opt[labelKey]}
                image={imageResolver?.(opt)}
                active={localValue.includes(val)}
                onClick={() => toggleValue(val)}
                infoOptionId={infoIdResolver?.(opt)}
                infoItemName={opt[labelKey]}
              />
            );
          })}
        </div>
      </Dialog>
    </>
  );
};
